module.exports = __webpack_public_path__ + "img/icon_circle-red.aa05b1b4.svg";